__turbopack_context__.v({
  "banner": "u_0H4W_banner",
  "logo": "u_0H4W_logo",
  "text": "u_0H4W_text",
});
